<template>
  <report-mobile-shift-rows
    :loading="loading.getDailyRestaurant"
    :rows="shiftRows"
    :stats="stats"
    :search="filters.search"
    empty-icon="mdi-leaf"
  ></report-mobile-shift-rows>
</template>

<script>
import ReportMealsTabGroceries from "@/components/report/meals/tabs/ReportMealsTabGroceries.vue";
import { SHIFTS } from "@/constants/shifts";
import hasShiftRows from "../../shared/hasShiftRows";
import ReportMobileShiftRows from "../ReportMobileShiftRows.vue";

/**
 * Mobilni prikaz "Namirnice": spisak namirnica po abecedi sa ukupnom količinom i količinom po smeni
 * (kuvar vidi šta je za koju smenu). Pretraga je u lupi zaglavlja. Nasleđuje učitavanje, štampu i Excel
 * iz ReportMealsTabGroceries.
 */
export default {
  name: "ReportMobileGroceries",
  extends: ReportMealsTabGroceries,
  mixins: [hasShiftRows],
  components: { ReportMobileShiftRows },
  computed: {
    shiftItems() {
      return this.groceries;
    },
    /** Porcije svih jela u izveštaju (namirnice su izračunate za njih). */
    mealPortions() {
      return SHIFTS.reduce((sum, shift) => {
        const meals = this.report?.[`${shift.id}-smena`] || {};
        return sum + Object.values(meals).reduce((total, meal) => total + (Number(meal.quantity) || 0), 0);
      }, 0);
    },
    stats() {
      return [
        { key: "groceries", label: this.$t("groceri"), value: this.groceries.length },
        { key: "meals", label: this.$t("report_desktop.total_meals"), value: this.mealPortions },
      ];
    },
  },
};
</script>
